/*
 * @format
 */

export const canDelete = (schedule, day, isHaloAir) => {
  if (!schedule || !day) {
    throw new Error('No schedule or day specified');
  }

  const scheduleDay = schedule.filter(event => {
    return event.day === day;
  });

  const minLength = isHaloAir ? 2 : 1;

  if (scheduleDay.length <= minLength) {
    return false;
  }

  return true;
};

export const canAdd = (schedule, day) => {
  if (!schedule || !day) {
    throw new Error('No schedule or day specified');
  }

  const scheduleDay = schedule.filter(event => {
    return event.day === day;
  });

  if (scheduleDay.length >= 6) {
    return false;
  }

  return true;
};

export const isValidStartTime = (schedule, day, startTime) => {
  if (!schedule || !day || !startTime) {
    throw new Error('No schedule, day or startTime specified');
  }

  const scheduleDay = schedule.filter(event => {
    return event.day === day;
  });

  const isValid = !scheduleDay.some(scheduleEvent => {
    return scheduleEvent.startTime === startTime;
  });

  return isValid;
};

export const canSetEndTime = (schedule, day, startTime) => {
  if (!schedule || !day || !startTime) {
    throw new Error('No schedule, day or startTime specified');
  }

  const scheduleDay = schedule.filter(event => {
    return event.day === day;
  });

  const scheduleDayStartTimes = scheduleDay.map(item => {
    return item.startTime;
  });

  const latestStartTimeOfTheDay = Math.max(...scheduleDayStartTimes);

  if (startTime >= latestStartTimeOfTheDay) {
    return false;
  }

  return true;
};
